export enum AttachmentType {
  IMAGE = "image",
  VIDEO = "video",
  AUTO = "auto",
}
